export enum PerformaValidationErrorCodes {
    InvalidSocialSecurityNumber = 'P-VAL-10',
    InvalidIban = 'P-VAL-11',
    DateNotInFuture = 'P-VAL-12',
    InvalidFileUploadNumber = 'P-VAL-13',
    FileInProgress = 'P-VAL-14',
    BooleanNotTrue = 'P-VAL-15',
    InvalidBirthdate = 'P-VAL-16',
}
